import { Image, Loader } from "@mantine/core";

import styles from "./view-file-modal-view.module.scss";
import { getDisplayValueForFileSize } from "@/utils/fileSize.ts";
import { Toast } from "@/components/Toast";

type ViewFileModalViewProps = {
  title: string;
  fileUrls: string[];
  size: number;
  isLoading: boolean;
  hasError: boolean;
};

export const ViewFileModalView = ({
  title,
  fileUrls,
  size,
  isLoading,
  hasError,
}: ViewFileModalViewProps) => (
  <>
    <h2 className={styles.modalContentHeader}>{title}</h2>
    {isLoading && (
      <div className={styles.loadingContainer}>
        <Loader className={styles.loadingSpinner} />
        {"Loading document files"}
      </div>
    )}
    {hasError && (
      <Toast variant="error">
        {
          "There was an issue loading the files in your document. Please try again"
        }
        {"later."}
      </Toast>
    )}
    {!isLoading && !hasError && (
      <>
        <p className={styles.fileSizeDescription}>
          {getDisplayValueForFileSize(size)}
        </p>
        <div className={styles.previewContainer}>
          {fileUrls.map((fileUrl) => (
            <Image
              key={fileUrl}
              src={fileUrl}
              className={styles.filePreviewImage}
            />
          ))}
        </div>
      </>
    )}
  </>
);
